'use client'

import { UserCircle, X } from 'lucide-react'
import UserDocsLink from '@/components/shared/UserDocsLink'

interface HeaderProps {
  onClose: () => void
}

export function Header({ onClose }: HeaderProps) {
  return (
    <div className="mb-3 sm:mb-6 px-2 relative">
      <div className="text-center">
        <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[var(--theme-primary)] to-[var(--theme-primary-dark)] text-white shadow-lg sm:mb-3 sm:h-16 sm:w-16">
          <UserCircle className="h-6 w-6 sm:h-8 sm:w-8" />
        </div>
        <h1 className="pm-heading-1 text-lg sm:text-2xl mb-1">Profile Settings</h1>
      </div>
      <div className="absolute right-2 top-0 flex items-center gap-2">
        <UserDocsLink
          docsPath="/getting-started/my-corner#profile"
          label="User guide: Profile settings"
        />
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center justify-center rounded-lg border border-gray-200 bg-white p-2 text-gray-400 transition-colors hover:border-gray-300 hover:text-gray-600 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-500 dark:hover:border-gray-600 dark:hover:text-gray-300"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  )
}
